import { render } from "./changeNumPriceModel.vue?vue&type=template&id=4450879c"
import script from "./changeNumPriceModel.vue?vue&type=script&lang=js"
export * from "./changeNumPriceModel.vue?vue&type=script&lang=js"

import "./changeNumPriceModel.vue?vue&type=style&index=0&id=4450879c&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__